import { z } from "zod";
export const mailboxMemberSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    name: z.string(),
});
export const mailboxSchema = z.object({
    id: z.string(),
    label: z.string().min(1),
    emailAddress: z.string().email(),
    calendarName: z.string().min(1),
    isActive: z.boolean(),
    markAsReadEnabled: z.boolean(),
    calendarSyncEnabled: z.boolean(),
    backfillDays: z.number().int().min(1).max(90),
    createdAt: z.string(),
    updatedAt: z.string(),
    users: z.array(mailboxMemberSchema),
});
export const mailboxCreateInputSchema = z.object({
    label: z.string().min(1, "Label richiesta"),
    emailAddress: z.string().email("Email non valida"),
    calendarName: z.string().min(1, "Nome calendario richiesto"),
    isActive: z.boolean().optional(),
    markAsReadEnabled: z.boolean().optional(),
    calendarSyncEnabled: z.boolean().optional(),
    backfillDays: z.number().int().min(1).max(90).optional(),
});
export const mailboxUpdateInputSchema = z
    .object({
    label: z.string().min(1, "Label richiesta").optional(),
    calendarName: z.string().min(1, "Nome calendario richiesto").optional(),
    isActive: z.boolean().optional(),
    markAsReadEnabled: z.boolean().optional(),
    calendarSyncEnabled: z.boolean().optional(),
    backfillDays: z.number().int().min(1).max(90).optional(),
})
    .refine((v) => v.label !== undefined ||
    v.calendarName !== undefined ||
    v.isActive !== undefined ||
    v.markAsReadEnabled !== undefined ||
    v.calendarSyncEnabled !== undefined ||
    v.backfillDays !== undefined, "Almeno un campo richiesto");
export const testConnectionResultSchema = z.object({
    email: z.object({ ok: z.boolean(), error: z.string().optional() }),
    calendar: z.object({ ok: z.boolean(), error: z.string().optional() }),
});
//# sourceMappingURL=mailbox.js.map